import { BymaActivitiesDetailsProps } from "./types";
import { MERK_ACTIVITY_TYPE } from "@letsbit/malcolmlb";
import { BackButton } from "components/BackButton";
import { Drawer } from "antd";
import { ActivityDetailsReceipt } from "./components/ActivityDetailsReceipt";
import { ActivityDetailsCoupon } from "./components/ActivityDetailsCoupon";
import { ActivityDetailsCheckingAccountMovement } from "./components/ActivityDetailsCheckingAccountMovement";

export const BymaActivitiesDetails: React.FC<BymaActivitiesDetailsProps> = ({
  data,
  onClose,
}) => {
  return (
    <Drawer
      width="33%"
      placement="right"
      keyboard={true}
      closable={false}
      onClose={onClose}
      open={!!data}
      getContainer=".ion-root"
    >
      <div className="flex flex-col gap-y-6">
        <BackButton onClick={onClose} />
        {data?.type === MERK_ACTIVITY_TYPE.RECEIPT && (
          <ActivityDetailsReceipt data={data} />
        )}
        {data?.type === MERK_ACTIVITY_TYPE.COUPON && (
          <ActivityDetailsCoupon data={data} />
        )}
        {data?.type === MERK_ACTIVITY_TYPE.CHECKING_ACCOUNT_MOVEMENT && (
          <ActivityDetailsCheckingAccountMovement data={data} />
        )}
      </div>
    </Drawer>
  );
};
